import { render, staticRenderFns } from "./ApprovalLineForm.vue?vue&type=template&id=4afc5c4c&scoped=true&"
import script from "./ApprovalLineForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalLineForm.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalLineForm.vue?vue&type=style&index=0&id=4afc5c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc5c4c",
  null
  
)

export default component.exports